import React, { useState, useEffect } from "react";
import LoadCSSforfirstTime from "../../../../../CloudStorage/LoadCSSforfirstTime";
import SubmittedRequest from "./AllPurchasedOrders/SubmittedRequest";
import ActiveOrders from "./AllPurchasedOrders/ActiveOrders";
import RequestHistory from "./AllPurchasedOrders/RequestHistory";
import { useRouteBaseStateContext } from "../../../../../Context/RouteBaseStateContext";

export default function PurchasedOrders({ postcounts }) {
  const { urlstate, setMyorderPurchasedordersroute } =
    useRouteBaseStateContext();

  const path = "Assets/scss/myorders.module.scss";
  const [activeTab, setActiveTab] = useState("PurchasedOrdersSubmittedRequest");

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  useEffect(() => {
    if (urlstate?.myorderPurchasedordersroute) {
      setActiveTab(
        urlstate?.myorderPurchasedordersroute ||
          "PurchasedOrdersSubmittedRequest"
      );
    } else {
      setActiveTab("PurchasedOrdersSubmittedRequest");
    }
  }, [urlstate, urlstate?.myorderPurchasedordersroute]);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setMyorderPurchasedordersroute(tab);
  };

  const prc =
    (Number(postcounts?.bxp) || 0) +
    (Number(postcounts?.sale) || 0) +
    (Number(postcounts?.rental) || 0);

  const rhc =
    (Number(postcounts?.bxp_history) || 0) +
    (Number(postcounts?.sale_history) || 0) +
    (Number(postcounts?.rental_history) || 0);
  const ahc =
    (Number(postcounts?.bxp_active) || 0) +
    (Number(postcounts?.sale_active) || 0) +
    (Number(postcounts?.rental_active) || 0);

  return (
    <div className="order-tabs">
      <ul className="nav nav-tabs">
        <li className="nav-item">
          <a
            className={`nav-link ${
              activeTab == "PurchasedOrdersSubmittedRequest" ? "active" : ""
            }`}
            onClick={() => handleTabClick("PurchasedOrdersSubmittedRequest")}
          >
            Submitted request ({prc || 0})
          </a>
        </li>
        <li className="nav-item">
          <a
            className={`nav-link ${
              activeTab == "PurchasedOrdersActiveOrders" ? "active" : ""
            }`}
            onClick={() => handleTabClick("PurchasedOrdersActiveOrders")}
          >
            Active orders ({ahc || 0})
          </a>
        </li>
        <li className="nav-item">
          <a
            className={`nav-link ${
              activeTab == "PurchasedOrdersRequestHistory" ? "active" : ""
            }`}
            onClick={() => handleTabClick("PurchasedOrdersRequestHistory")}
          >
            Declined request history ({rhc || 0})
          </a>
        </li>
      </ul>
      <div className="tab-content">
        {activeTab == "PurchasedOrdersSubmittedRequest" && (
          <SubmittedRequest postcounts={postcounts} />
        )}
        {activeTab == "PurchasedOrdersActiveOrders" && (
          <ActiveOrders postcounts={postcounts} />
        )}
        {activeTab == "PurchasedOrdersRequestHistory" && (
          <RequestHistory postcounts={postcounts} />
        )}
      </div>
    </div>
  );
}
